import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
} from '@angular/router';
import { Observable, map, catchError, of } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AlreadyAuthenticatedGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authenticationService.verifyUser().pipe(
      map(() => {
        if (this.authenticationService.isAuthenticated()) {
          this.router.navigateByUrl('home');
          return false;
        }
        return true;
      }),
      catchError(() => {
        // TODO: angular prints error in console if this request returns 500 ???
        return of(true);
      })
    );
  }
}
